document.addEventListener('DOMContentLoaded', function () {
  const swatchMap = {
    'Antik Çeviz': 'https://cdn.shopify.com/s/files/1/0710/4145/0119/files/antik-eviz.png?v=1776608373',
    'Koyu Ceviz': 'https://cdn.shopify.com/s/files/1/0710/4145/0119/files/koyu-ceviz.png?v=1776608373',
    'Beyaz': 'https://cdn.shopify.com/s/files/1/0710/4145/0119/files/beyaz.png?v=1776608373',
    'Siyah': 'https://cdn.shopify.com/s/files/1/0710/4145/0119/files/siyah.png?v=1776608373',
    'Natural Çam': 'https://cdn.shopify.com/s/files/1/0710/4145/0119/files/natural-am.png?v=1776608373',
    'Lacivert': 'https://cdn.shopify.com/s/files/1/0710/4145/0119/files/lacivert.png?v=1776608373',
    'Yeşil': 'https://cdn.shopify.com/s/files/1/0710/4145/0119/files/ye-il.png?v=1776608373'
  };

  function buildSwatches() {
    document.querySelectorAll('fieldset').forEach(function (fieldset) {
      const legend = fieldset.querySelector('legend');
      if (!legend) return;
      const labelText = legend.innerText.trim();
      if (labelText !== 'Renk') return;
      if (fieldset.querySelector('.bourdua-swatch')) return;

      const inputs = fieldset.querySelectorAll('input[type="radio"]');
      inputs.forEach(function (input) {
        const label = fieldset.querySelector('label[for="' + input.id + '"]');
        if (!label) return;
        const value = input.value;
        const imgUrl = swatchMap[value];
        if (!imgUrl) return;

        label.innerHTML = '';
        label.classList.add('bourdua-swatch');
        label.title = value;

        const img = document.createElement('img');
        img.src = imgUrl;
        img.alt = value;
        label.appendChild(img);
      });
    });
  }

  buildSwatches();
});
